// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/raidboss/data/04-sb/trial/shinryu-ex.ts

import Conditions from '../../../../../resources/conditions';
import Outputs from '../../../../../resources/outputs';
import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

export interface Data extends RaidbossData {
  phase?: number;
  finalWing?: boolean;
  shakerTargets?: string[];
}

// Shinryu Unreal
const triggerSet: TriggerSet<Data> = {
  id: 'ShinryusDomainUnreal',
  zoneId: ZoneId.ShinryusDomainUnreal,
  timelineFile: 'shinryu-un.txt',
  triggers: [
    { // Earthen Fury
      id: 'ShinryuUn Phase 1',
      type: 'StartsUsing',
      netRegex: { id: 'C43A', source: 'Shinryu', capture: false },
      run: (data) => data.phase = 1,
    },
    { // Dark Matter
      id: 'ShinryuUn Phase 2',
      type: 'StartsUsing',
      netRegex: { id: 'C443', source: 'Shinryu', capture: false },
      run: (data) => data.phase = 2,
    },
    { // Protostar
      id: 'ShinryuUn Phase 3',
      type: 'StartsUsing',
      netRegex: { id: 'C440', source: 'Shinryu', capture: false },
      run: (data) => data.phase = 3,
    },
    { // Tidal Wave enrage
      id: 'ShinryuUn Phase 4',
      type: 'StartsUsing',
      netRegex: { id: 'C47B', source: 'Shinryu', capture: false },
      run: (data) => data.phase = 4,
    },
    {
      id: 'ShinryuUn Akh Morn',
      type: 'StartsUsing',
      netRegex: { id: 'C44F', source: 'Shinryu', capture: true },
      alertText: (data, matches, output) => {
        if (matches.target === data.me)
          return output.akhMornOnYou!();
        else if (data.role === 'tank')
          return output.akhMornOn!({ player: data.party.member(matches.target) });
      },
      infoText: (data, matches, output) => {
        if (matches.target === data.me || data.role === 'tank')
          return;

        return output.akhRhaiSpreadAndMove!();
      },
      outputStrings: {
        akhRhaiSpreadAndMove: {
          en: 'Akh Rhai: spread and move',
          de: 'Akh Rhai: Verteilen und bewegen',
          fr: 'Akh Rhai : Dispersion et bougez',
          ja: 'アク・ラーイ: 散開 動け',
          cn: '天光轮回：散开保持移动',
          ko: '아크 라이: 산개, 이동',
          tc: '天光輪迴：散開保持移動',
        },
        akhMornOnYou: {
          en: 'Akh Morn on YOU',
          de: 'Akh Morn auf DIR',
          fr: 'Akh Morn sur VOUS',
          ja: '自分にアク・モーン',
          cn: '死亡轮回点名',
          ko: '아크몬 대상자',
          tc: '死亡輪迴點名',
        },
        akhMornOn: {
          en: 'Akh Morn on ${player}',
          de: 'Akh Morn auf ${player}',
          fr: 'Akh Morn sur ${player}',
          ja: '${player}にアク・モーン',
          cn: '死亡轮回点${player}',
          ko: '"${player}" 아크몬',
          tc: '死亡輪迴點 ${player}',
        },
      },
    },
    {
      id: 'ShinryuUn Diamond Dust',
      type: 'StartsUsing',
      netRegex: { id: 'C439', source: 'Shinryu', capture: false },
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Ice: Stack + don\'t move',
          de: 'Eis: Sammeln + nicht bewegen',
          cn: '冰: 集合 + 不要动',
          ko: '얼음: 모이기 + 이동 멈추기',
        },
      },
    },
    {
      id: 'ShinryuUn Dragonfist',
      type: 'StartsUsing',
      netRegex: { id: 'C46D', source: 'Shinryu', capture: false },
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Out of middle',
          de: 'Raus aus der Mitte',
          fr: 'Sortez du milieu',
          ja: '中央から離れ',
          cn: '离开中间',
          ko: '중앙 피하기',
          tc: '離開中間',
        },
      },
    },
    {
      id: 'ShinryuUn Hellfire',
      type: 'StartsUsing',
      netRegex: { id: 'C437', source: 'Shinryu', capture: false },
      durationSeconds: 7,
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Get in water',
          de: 'In\'s Wasser',
          fr: 'Allez dans l\'eau',
          ja: '水に入る',
          cn: '进水圈',
          ko: '물 장판에 들어가기',
          tc: '進水圈',
        },
      },
    },
    {
      // TODO: the original trigger didn't differentiate the two ability ids.
      // Probably the phase conditional could get removed if it did.
      id: 'ShinryuUn Hypernova',
      type: 'StartsUsing',
      netRegex: { id: ['C481', 'C444'], source: 'Right Wing', capture: false },
      durationSeconds: 7,
      alertText: (data, _matches, output) => {
        if (data.phase === 3)
          return output.stopToGetFrozen!();

        return output.stackInWater!();
      },
      outputStrings: {
        stopToGetFrozen: {
          en: 'Stop + Get frozen',
          de: 'Stopp! Einfrieren lassen',
          fr: 'Arrêtez, laissez-vous geler',
          ja: '止まれ、凍結',
          cn: '停止移动 + 吃冻结',
          ko: '멈춰서 얼기',
          tc: '停止移動吃凍結',
        },
        stackInWater: {
          en: 'Stack in water',
          de: 'In Wasser stacken',
          fr: 'Packez-vous dans l\'eau',
          ja: '水に集合',
          cn: '在水圈分摊',
          ko: '물 장판에 모이기',
          tc: '在水圈分攤',
        },
      },
    },
    {
      id: 'ShinryuUn Judgement Bolt',
      type: 'StartsUsing',
      netRegex: { id: 'C438', source: 'Shinryu', capture: false },
      durationSeconds: 7,
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Out of water',
          de: 'Raus aus dem Wasser',
          fr: 'Sortez de l\'eau',
          ja: '水から離れ',
          cn: '离开水圈',
          ko: '물 장판 밖으로',
          tc: '離開水圈',
        },
      },
    },
    {
      id: 'ShinryuUn Levinbolt',
      type: 'StartsUsing',
      netRegex: {
        id: ['C446', 'C482', 'C486'],
        source: 'Right Wing',
        target: 'Right Wing',
        capture: false,
      },
      durationSeconds: 7,
      alertText: (data, _matches, output) => {
        if (data.phase === 3)
          return output.baitBoltKeepMoving!();

        return output.spreadOutNoWater!();
      },
      outputStrings: {
        baitBoltKeepMoving: {
          en: 'Bait bolt + keep moving',
          de: 'Blitz ködern, weiterbewegen',
          fr: 'Attirez la foudre, continuez à bouger',
          ja: '稲妻: 動き続ける',
          cn: '诱导闪电 + 保持移动',
          ko: '번개 공격 산개, 계속 움직이기',
          tc: '誘導閃電，保持移動',
        },
        spreadOutNoWater: {
          en: 'Spread out, no water',
          de: 'Verteilen und nicht in\'s Wasser',
          fr: 'Dispersez-vous en dehors de l\'eau',
          ja: '散開、水に入らない',
          cn: '散开，离开水圈',
          ko: '산개, 물장판 X',
          tc: '散開，離開水圈',
        },
      },
    },
    {
      id: 'ShinryuUn Levinbolt Phase 3',
      type: 'StartsUsing',
      netRegex: {
        id: ['C446', 'C482', 'C486'],
        source: 'Right Wing',
        target: 'Right Wing',
        capture: false,
      },
      condition: (data) => data.phase === 3,
      delaySeconds: 9.5,
      response: Responses.moveAway('alarm'),
    },
    {
      id: 'ShinryuUn Icicle Left',
      type: 'Ability',
      netRegex: { id: 'C44B', source: 'Icicle', capture: true },
      condition: (_data, matches) => {
        return Math.round(parseFloat(matches.x)) === -30 &&
          Math.round(parseFloat(matches.y)) === -15;
      },
      alarmText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Icicle, lean west',
          de: 'Eiszapfen, nach westen',
          fr: 'Stalactite, penchez vers l\'ouest',
          ja: 'アイシクル: 西へ',
          cn: '冰柱, 偏左站',
          ko: '고드름, 왼쪽 먼저',
          tc: '冰柱，去西邊',
        },
      },
    },
    {
      id: 'ShinryuUn Icicle Right',
      type: 'Ability',
      netRegex: { id: 'C44B', source: 'Icicle' },
      condition: (_data, matches) => {
        return Math.round(parseFloat(matches.x)) === -30 &&
          Math.round(parseFloat(matches.y)) === -25;
      },
      alarmText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Icicle, lean east',
          de: 'Eiszapfen, nach Osten',
          fr: 'Stalactite, penchez vers l\'est',
          ja: 'アイシクル: 東へ',
          cn: '冰柱, 偏右站',
          ko: '고드름, 오른쪽 먼저',
          tc: '冰柱，去東邊',
        },
      },
    },
    {
      id: 'ShinryuUn Tidal Wave',
      type: 'StartsUsing',
      netRegex: { id: 'C436', source: 'Shinryu', capture: false },
      delaySeconds: 3,
      durationSeconds: 5,
      response: Responses.knockback(),
    },
    {
      id: 'ShinryuUn Final Tidal Wave',
      type: 'StartsUsing',
      netRegex: { id: 'C47B', source: 'Shinryu', capture: false },
      condition: (data) => data.role === 'healer',
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'no more heals needed',
          de: 'keine Heilung mehr nötig',
          fr: 'Plus besoin de soigner',
          ja: 'ヒールはもう要らない',
          cn: '狂暴读条，不用奶了',
          ko: '힐 그만',
          tc: '狂暴讀條，不用補了',
        },
      },
    },
    {
      id: 'ShinryuUn Tail Slap',
      type: 'StartsUsing',
      netRegex: { id: 'C43E', source: 'Tail', capture: false },
      delaySeconds: 2,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Tail: Switch targets',
          de: 'Schweif: Zielwechsel',
          fr: 'Queue : Changez de cible',
          ja: '尾: タゲチェンジ',
          cn: '打尾巴',
          ko: '꼬리 공격',
          tc: '打尾巴',
        },
      },
    },
    {
      id: 'ShinryuUn Heart',
      type: 'AddedCombatant',
      netRegex: { name: 'The Worm\'s Heart', capture: false },
      condition: (data) => {
        // Prevent ugly heart message on wipe.
        return data.phase === 1;
      },
      // TODO: If tail is alive, delay this message?
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Heart: Switch targets',
          de: 'Herz: Ziel wechseln',
          fr: 'Cœur : Changez de cible',
          ja: '心核: タゲチェンジ',
          cn: '打核心',
          ko: '심핵 공격',
          tc: '打核心',
        },
      },
    },
    {
      // TODO: math out locations and call directions if we get a log containing any of these IDs.
      id: 'ShinryuUn Gyre Charge',
      type: 'StartsUsing',
      netRegex: { id: ['BFEB', 'BFEC', 'C45F'], source: 'Shinryu', capture: false },
      alarmText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Avoid divebomb',
          de: 'Divebomb ausweichen',
          fr: 'Évitez la bombe plongeante',
          ja: 'ダイブボムに避け',
          cn: '躲避俯冲',
          ko: '회전 돌진 피하기',
          tc: '躲避俯衝',
        },
      },
    },
    {
      id: 'ShinryuUn Death Sentence',
      type: 'StartsUsing',
      netRegex: { id: 'C466', source: 'Hakkinryu' },
      alertText: (data, matches, output) => {
        if (matches.target === data.me)
          return output.deathSentenceOnYou!();
        else if (data.role === 'healer')
          return output.deathSentenceOn!({ player: data.party.member(matches.target) });
      },
      infoText: (data, matches, output) => {
        if (matches.target !== data.me && data.role !== 'healer')
          return output.deathSentenceOn!({ player: data.party.member(matches.target) });
      },
      outputStrings: {
        deathSentenceOn: {
          en: 'Death Sentence on ${player}',
          de: 'Todesurteil auf ${player}',
          fr: 'Peine de mort sur ${player}',
          ja: '${player}にデスセンテンス',
          cn: '死刑点 ${player}',
          ko: '"${player}" 사형 선고',
          tc: '死刑點 ${player}',
        },
        deathSentenceOnYou: {
          en: 'Death Sentence on YOU',
          de: 'Todesurteil auf DIR',
          fr: 'Peine de mort sur VOUS',
          ja: '自分にデスセンテンス',
          cn: '死刑点名',
          ko: '사형 선고 대상자',
          tc: '死刑點名',
        },
      },
    },
    {
      id: 'ShinryuUn Tera Slash',
      type: 'StartsUsing',
      netRegex: { id: 'C478', source: 'Shinryu' },
      response: Responses.tankBusterSwap(),
    },
    {
      id: 'ShinryuUn Wormwail',
      type: 'StartsUsing',
      netRegex: { id: 'C475', source: 'Shinryu', capture: false },
      response: Responses.getUnder('alert'),
    },
    {
      id: 'ShinryuUn Breath',
      type: 'StartsUsing',
      netRegex: { id: 'C477', source: 'Shinryu', capture: false },
      response: Responses.awayFromFront(),
    },
    {
      id: 'ShinryuUn Final Left Wing',
      type: 'StartsUsing',
      netRegex: { id: 'C47D', source: 'Left Wing', capture: false },
      condition: (data) => !data.finalWing,
      alertText: (_data, _matches, output) => output.text!(),
      run: (data) => data.finalWing = true,
      outputStrings: {
        text: {
          en: 'Kill left first',
          de: 'linken Flügel zuerst',
          fr: 'Tuez l\'aile gauche d\'abord',
          ja: 'レフトウィングに攻撃',
          cn: '优先击杀左翼',
          ko: '왼쪽 날개 먼저',
          tc: '擊殺左翼',
        },
      },
    },
    {
      id: 'ShinryuUn Final Right Wing',
      type: 'StartsUsing',
      netRegex: { id: 'C47E', source: 'Right Wing', capture: false },
      condition: (data) => !data.finalWing,
      alertText: (_data, _matches, output) => output.text!(),
      run: (data) => data.finalWing = true,
      outputStrings: {
        text: {
          en: 'Kill right first',
          de: 'rechten Flügel zuerst',
          fr: 'Tuez l\'aile droite d\'abord',
          ja: 'ライトウィングに攻撃',
          cn: '优先击杀右翼',
          ko: '오른쪽 날개 먼저',
          tc: '擊殺右翼',
        },
      },
    },
    {
      id: 'ShinryuUn Tethers',
      type: 'HeadMarker',
      netRegex: { id: '0061' },
      condition: Conditions.targetIsYou(),
      delaySeconds: 3.8,
      infoText: (data, _matches, output) => {
        if (data.phase === 3)
          return output.breakTethersThenStack!();

        return output.breakTethers!();
      },
      outputStrings: {
        breakTethersThenStack: {
          en: 'Break tethers => stack',
          de: 'Kette zerreissen, dann stack',
          fr: 'Cassez les liens, puis packez-vous',
          ja: '鎖を引き、集合',
          cn: '拉断连线 => 分摊',
          ko: '선 끊고 모이기',
          tc: '拉斷連線然後分攤',
        },
        breakTethers: {
          en: 'break tethers',
          de: 'Ketten zerreissen',
          fr: 'Cassez les liens',
          ja: '鎖',
          cn: '拉断连线',
          ko: '선 끊기',
          tc: '拉斷連線',
        },
      },
    },
    {
      id: 'ShinryuUn Tail Marker',
      type: 'HeadMarker',
      netRegex: { id: '007E' },
      condition: Conditions.targetIsYou(),
      alarmText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Tail marker on YOU',
          de: 'Schweifmarker auf dir',
          fr: 'Marqueur Queue sur VOUS',
          ja: '自分にテイル',
          cn: '龙尾点名',
          ko: '꼬리 징 대상자',
          tc: '龍尾點名',
        },
      },
    },
    {
      id: 'ShinryuUn Shakers',
      type: 'HeadMarker',
      netRegex: { id: '0028' },
      condition: (data, matches) => {
        data.shakerTargets ??= [];
        data.shakerTargets.push(matches.target);
        return data.shakerTargets.length === 2;
      },
      alarmText: (data, _matches, output) => {
        if (data.shakerTargets?.includes(data.me))
          return output.earthshakerOnYou!();
      },
      alertText: (data, _matches, output) => {
        if (!data.shakerTargets || !data.shakerTargets.includes(data.me))
          return output.avoidEarthshakers!();
      },
      run: (data) => delete data.shakerTargets,
      outputStrings: {
        avoidEarthshakers: {
          en: 'avoid earthshakers',
          de: 'Stöße ausweichen',
          fr: 'Évitez les secousses',
          ja: 'アースシェーカーに避け',
          cn: '躲避大地动摇',
          ko: '어스 피하기',
          tc: '遠離大地動搖',
        },
        earthshakerOnYou: Outputs.earthshakerOnYou,
      },
    },
    {
      id: 'ShinryuUn Cocoon Marker',
      type: 'HeadMarker',
      netRegex: { id: '0039' },
      condition: Conditions.targetIsYou(),
      response: Responses.spread(),
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Hakkinryu': 'Hakkinryu',
        'Left Wing': 'link(?:e|er|es|en) Schwinge',
        'Right Wing': 'recht(?:e|er|es|en) Schwinge',
        'Shinryu': 'Shinryu',
        'Tail': 'Schwanz',
        'The Worm\'s Heart': 'Shinryus Herz',
        'Icicle': 'Eiszapfen',
        'Cocoon': 'Lichtsphäre',
      },
      'replaceText': {
        '--Reiryu Adds--': '--Reiryu Adds--',
        'Aerial Blast': 'Windschlag',
        'Akh Morn': 'Akh Morn',
        'Akh Rhai': 'Akh Rhai',
        'Atomic Ray': 'Atomstrahlung',
        'Benighting Breath': 'Dunkelhauch',
        'Cocoon Markers': 'Kokon Marker',
        'Dark Matter': 'Dunkelmaterie',
        'Diamond Dust': 'Diamantenstaub',
        'Dragonfist': 'Drachenfaust',
        'Earth Breath': 'Erdatem',
        'Earthen Fury': 'Gaias Zorn',
        'First Wing': 'Erster Flügel',
        'Gyre Charge': 'Wirbel-Aufladung',
        'Hellfire': 'Höllenfeuer',
        'Hypernova': 'Supernova',
        'Ice Storm': 'Eissturm',
        'Icicle Impact': 'Eiszapfen-Schlag',
        'Judgment Bolt': 'Ionenschlag',
        'Levinbolt': 'Keraunisches Feld',
        'Meteor Impact': 'Meteoreinschlag',
        'Phase': 'Phase',
        'Protostar': 'Protostern',
        'Reiyu Adds': 'Reiyu Adds',
        'Second Wing': 'Zweiter Flügel',
        'Spikesicle': 'Eislanze',
        'Super Cyclone': 'Superzyklon',
        'Shatter': 'Zerfallen',
        'Summon Icicle': 'Flugeis',
        'TAP BUTTON OR ELSE': 'DRÜCKE TASTEN ETC',
        'Tail Marker': 'Schweifmarker',
        'Tail Slap': 'Schweifklapser',
        'Tail Spit': 'Schweifspieß',
        'Tera Slash': 'Tera-Schlag',
        'Tethers': 'Verbindungen',
        'Tidal Wave': 'Flutwelle',
        'Touchdown': 'Himmelssturz',
        'Wormwail': 'Shinryus Ruf',
      },
    },
    {
      'locale': 'fr',
      'missingTranslations': true,
      'replaceSync': {
        'Hakkinryu': 'Hakkinryu',
        'Icicle': 'stalactite',
        'Left Wing': 'aile gauche',
        'Right Wing': 'aile droite',
        'Shinryu': 'Shinryu',
        'The Worm\'s Heart': 'cœur du dragon',
        'Tail': 'queue',
        'Cocoon': 'cocon de lumière',
      },
      'replaceText': {
        '--Phase': '--Phase',
        '--Reiryu Adds--': '--Adds Reiryu--',
        'Aerial Blast': 'Rafale aérienne',
        'Atomic Ray': 'Rayon atomique',
        'Cocoon Markers': 'Marqueurs Cocon',
        'Dark Matter': 'Matière sombre',
        'Diamond Dust': 'Poussière de diamant',
        'Dragonfist': 'Poing dragon',
        'Earth Breath': 'Souffle de terre',
        'Earthen Fury': 'Fureur tellurique',
        'First Wing': 'Première aile',
        'Gyre Charge': 'Gyrocharge',
        'Hellfire': 'Flammes de l\'enfer',
        'Hypernova': 'Hypernova',
        'Ice Storm': 'Tempête de glace',
        'Judgment Bolt': 'Éclair du jugement',
        'Levinbolt': 'Fulguration',
        'Meteor Impact': 'Impact de météore',
        'Protostar': 'Proto-étoile',
        'Reiyu Adds': 'Adds Ryu',
        'Second Wing': 'Seconde aile',
        'Summon Icicle': 'Appel de stalactite',
        'Tail Marker': 'Marqueur Queue',
        'Tail Slap': 'Gifle caudale',
        'Tail Spit': 'Broche caudale',
        'TAP BUTTON OR ELSE': 'CLIQUEZ SUR LE BOUTON OU AUTRE',
        'Tera Slash': 'TéraTaillade',
        'Tethers': 'Liens',
        'Tidal Wave': 'Raz-de-marée',
        'Touchdown': 'Atterrissage',
        'Akh Morn': 'Akh Morn',
        'Icicle Impact': 'Impact de stalactite',
        'Spikesicle': 'Stalactopointe',
        'Akh Rhai': 'Akh Rhai',
        'Super Cyclone': 'Super cyclone',
        'Shatter': 'Éclatement',
        'Wormwail': 'Gémissement draconique',
        'Benighting Breath': 'Souffle enténébrant',
      },
    },
    {
      'locale': 'ja',
      'missingTranslations': true,
      'replaceSync': {
        'Left Wing': 'レフトウィング',
        'Right Wing': 'ライトウィング',
        'Shinryu': '神龍',
        'Tail': '神龍の尾',
        'The Worm\'s Heart': '神龍の心核',
        'Icicle': 'アイシクル',
        'Cocoon': '光の繭',
        'Hakkinryu': '白金龍',
      },
      'replaceText': {
        'Aerial Blast': 'エリアルブラスト',
        'Akh Morn': 'アク・モーン',
        'Atomic Ray': 'アトミックレイ',
        'Cocoon Markers': 'マユ マーク',
        'Dark Matter': 'ダークマター',
        'Diamond Dust': 'ダイアモンドダスト',
        'Dragonfist': '龍掌',
        'Earth Breath': 'アースブレス',
        'Earthen Fury': '大地の怒り',
        'First Wing': '翼一つ目',
        'Gyre Charge': 'ジャイヤチャージ',
        'Hellfire': '地獄の火炎',
        'Hypernova': 'スーパーノヴァ',
        'Ice Storm': '吹雪',
        'Judgment Bolt': '裁きの雷',
        'Levinbolt': '稲妻',
        'Meteor Impact': 'メテオインパクト',
        'Phase': 'フェイス',
        'Protostar': 'プロトスター',
        'Reiyu Adds': '雑魚',
        'Second Wing': '翼二つ目',
        'Summon Icicle': 'サモン・アイシクル',
        'TAP BUTTON OR ELSE': 'ボタンを押せ！',
        'Tail Marker': 'テイル マーク',
        'Tail Slap': 'テールスラップ',
        'Tail Spit': 'テールスピット',
        'Tera Slash': 'テラスラッシュ',
        'Tethers': '線',
        'Tidal Wave': 'タイダルウェイブ',
        'Touchdown': 'タッチダウン',
        'Icicle Impact': 'アイシクルインパクト',
        'Spikesicle': 'アイシクルスパイク',
        'Akh Rhai': 'アク・ラーイ',
        'Super Cyclone': 'スーパーサイクロン',
        'Shatter': '破砕',
        'Wormwail': '神龍の咆哮',
        'Benighting Breath': 'ダークネスブレス',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Cocoon': '光茧',
        'Icicle': '冰柱',
        'Left Wing': '左翼',
        'Right Wing': '右翼',
        'Shinryu': '神龙',
        'Tail': '龙尾',
        'The Worm\'s Heart': '神龙的核心',
        'Hakkinryu': '白金龙',
      },
      'replaceText': {
        'Aerial Blast': '大气爆发',
        'Akh Morn': '死亡轮回',
        'Akh Rhai': '天光轮回',
        'Atomic Ray': '原子射线',
        'Benighting Breath': '黑暗吐息',
        'Cocoon Markers': '光茧点名',
        'Dark Matter': '暗物质',
        'Diamond Dust': '钻石星尘',
        'Dragonfist': '龙掌',
        'Earth Breath': '大地吐息',
        'Earthen Fury': '大地之怒',
        'First Wing': '第一只翅膀',
        'Gyre Charge': '螺旋冲锋',
        'Hellfire': '地狱之火炎',
        'Hypernova': '超新星',
        'Icicle Impact': '冰柱冲击',
        'Ice Storm': '吹雪',
        'Judgment Bolt': '制裁之雷',
        'Levinbolt': '闪电',
        'Meteor Impact': '陨石冲击',
        'Phase': '阶段',
        'Protostar': '原恒星',
        'Reiryu Adds': '灵龙出现',
        'Second Wing': '第二只翅膀',
        'Shatter': '破碎',
        'Spikesicle': '冰柱突刺',
        'Summon Icicle': '召唤冰柱',
        'Super Cyclone': '超级气旋',
        'TAP BUTTON OR ELSE': 'XJB按',
        'Tail Marker': '尾巴点名',
        'Tail Slap': '尾部猛击',
        'Tail Spit': '尾部重击',
        'Tera Slash': '万亿斩击',
        'Tethers': '连线',
        'Tidal Wave': '巨浪',
        'Touchdown': '空降',
        'Wormwail': '神龙啸',
      },
    },
    {
      'locale': 'tc',
      'missingTranslations': true,
      'replaceSync': {
        'Cocoon': '光繭',
        'Icicle': '冰柱',
        'Left Wing': '左翼',
        'Right Wing': '右翼',
        'Shinryu': '神龍',
        'Tail': '龍尾',
        'The Worm\'s Heart': '神龍的核心',
        'Hakkinryu': '白金龍',
      },
      'replaceText': {
        'Aerial Blast': '大氣爆發',
        'Akh Morn': '死亡輪迴',
        'Akh Rhai': '天光輪迴',
        'Atomic Ray': '原子射線',
        'Benighting Breath': '黑暗吐息',
        'Cocoon Markers': '光繭點名',
        'Dark Matter': '黑暗物質',
        'Diamond Dust': '鑽石星塵',
        'Dragonfist': '龍掌',
        'Earth Breath': '大地吐息',
        'Earthen Fury': '大地之怒',
        'First Wing': '第一隻翅膀',
        'Gyre Charge': '螺旋衝鋒',
        'Hellfire': '地獄之火炎',
        'Hypernova': '超新星',
        'Icicle Impact': '冰柱衝擊',
        'Ice Storm': '吹雪',
        'Judgment Bolt': '制裁之雷',
        'Levinbolt': '閃電',
        'Meteor Impact': '隕石衝擊',
        'Phase': '階段',
        'Protostar': '原恆星',
        'Reiryu Adds': '靈龍出現',
        'Second Wing': '第二隻翅膀',
        'Shatter': '破碎',
        'Spikesicle': '冰柱突刺',
        'Summon Icicle': '召喚冰柱',
        'Super Cyclone': '超級颶風',
        'TAP BUTTON OR ELSE': '按按鈕！',
        'Tail Marker': '尾巴點名',
        'Tail Slap': '尾部猛擊',
        'Tail Spit': '尾部重擊',
        'Tera Slash': '萬億斬擊',
        'Tethers': '連線',
        'Tidal Wave': '巨浪',
        'Touchdown': '空降',
        'Wormwail': '神龍嘯',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Hakkinryu': '백금룡',
        'Left Wing': '왼쪽 날개',
        'Right Wing': '오른쪽 날개',
        'Shinryu': '신룡',
        'Tail(?! )': '신룡의 꼬리',
        'The Worm\'s Heart': '신룡의 심핵',
        'Icicle': '고드름',
        'Cocoon': '빛의 고치',
      },
      'replaceText': {
        'T\\/H': '탱/힐',
        'healer[s]*': '힐러',
        'dps': '딜러',
        'tank': '탱커',
        'Aerial Blast': '대기 폭발',
        'Akh Morn': '아크 몬',
        'Atomic Ray': '원자 파동',
        'Cocoon Markers': '빛의 고체 징',
        'Dark Matter': '암흑물질',
        'Diamond Dust': '다이아몬드 더스트',
        'Dragonfist': '용의 손바닥',
        'Earth Breath': '대지의 숨결',
        'Earthen Fury': '대지의 분노',
        'First Wing': '첫번째 날개',
        'Gyre Charge': '회전 돌진',
        'Hellfire': '지옥의 화염',
        'Hypernova': '초신성',
        'Ice Storm': '눈보라',
        'Judgment Bolt': '심판의 벼락',
        'Levinbolt': '우레',
        'Meteor Impact': '운석 낙하',
        'Phase': '페이즈',
        'Protostar': '원시별',
        'Reiryu Adds': '영룡 등장',
        'Second Wing': '두번째 날개',
        'Summon Icicle': '고드름 소환',
        'TAP BUTTON OR ELSE': '긴 급 조 작',
        'Tail Marker': '꼬리 징',
        'Tail Slap': '꼬리치기',
        'Tail Spit': '꼬리 찌르기',
        'Tera Slash': '테라 슬래시',
        'Tethers': '선',
        'Tidal Wave': '해일',
        'Touchdown': '착지',
        'Icicle Impact': '고드름 낙하',
        'Spikesicle': '고드름 돌진',
        'Akh Rhai': '아크 라이',
        'Super Cyclone': '대형 돌개바람',
        'Shatter': '파쇄',
        'Wormwail': '신룡의 포효',
        'Benighting Breath': '어둠의 숨결',
      },
    },
  ],
};

export default triggerSet;
